var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"machines pad"},[_c('machines-list',{attrs:{"show-warnings":true},on:{"selected":_vm.selected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }